<div class="property-list">
    <app-property-card *ngFor="let item of properties; trackBy: trackById"
                       [vm]="item" (select)="open($event)"></app-property-card>
</div>
